<template>
  <div id="main">
    <LogCrowJumbotron />
    <LogCards
      v-if="logs.length > 0"
      v-bind:logs="logs"
    />
    <LatestLog v-if="logs.length === 0" />
  </div>
</template>

<script>
import LogCrowJumbotron from './LogCrowJumbotron.vue'
import LogCards from './LogCards.vue'
import LatestLog from './LatestLog.vue'

export default {
  name: 'main',
  components: {
    LogCrowJumbotron,
    LogCards,
    LatestLog,
  },
  data () {
    return {
    }
  },
  computed: {
    logs(){
      return this.$store.getters.logs
    }
  },
  beforeCreated: function() {
    this.$store.commit('setLogs', [])
  }
}
</script>

<style>
.main {
  min-height: 800px;
}
</style>
